import React from "react";
import * as yup from "yup";
import { Formik, Form } from "formik";
import {
    customStringify,
    error_alert,
    stringNotEmpty,
    success_alert,
} from "../../utils";
import TextField from "../../components/FormikFields/TextField";
import { BiLoaderAlt } from "react-icons/bi";
import { Link, useNavigate } from "react-router-dom";
import { network_tl, required_tl } from "../../translations";
import { FormattedMessage, useIntl } from "react-intl";
import useApi from "../../hooks/useApi";

const Login = () => {
    const intl = useIntl();
    const navigate = useNavigate();
    const { Axios } = useApi();

    const initialValues = {
        email: "",
    };
    yup.addMethod(yup.string, "stringNotEmpty", stringNotEmpty);
    const validationSchema = yup.object({
        email: yup.string().email().required(required_tl(intl)),
    });

    const handleSubmit = async (values, formikBag) => {
        try {
            const result = await Axios.post("api/user/forgot-password", values);
            success_alert(result.data.description);
            navigate("/")
        } catch (e) {
            if (e.response) {
                error_alert(customStringify(e.response.data.description))
            } else {
                error_alert(network_tl(intl));
            }
        }
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
        >
            {(form) => (
                <Form className="mt-5 w-[90%] mx-auto">
                    <>
                    
                        <div className="space-y-5">
                            <div>
                                <TextField
                                    type="email"
                                    field="email"
                                    label_text={
                                        <FormattedMessage
                                            id="email"
                                            defaultMessage="Email"
                                        />
                                    }
                                    form={form}
                                />
                            </div>
                            <div className="flex items-center pt-3 pb-3">
                                <button
                                    type="submit"
                                    disabled={form.isSubmitting}
                                    className="block w-full btn btn-primary"
                                >
                                    <p>
                                        {form.isSubmitting ? (
                                            <BiLoaderAlt className="animate-spin text-white text-3xl mx-auto" />
                                        ) : (
                                            intl.formatMessage({ id: "submit", defaultMessage: "Submit" })
                                        )}
                                    </p>
                                </button>
                            </div>

                            <hr className="" />
                            <p className="text-xs md:text-sm text-center">
                                <FormattedMessage
                                    id="back_login"
                                    defaultMessage={
                                        "Back to {link}"
                                    }
                                    values={{
                                        link: (
                                            <Link
                                                className="text-primary underline font-medium"
                                                to="/"
                                            >
                                                <FormattedMessage id="login" defaultMessage={"Login"} />
                                            </Link>
                                        ),
                                    }}
                                />
                            </p>
                        </div>
                    </>
                </Form>
            )}
        </Formik>
    );
};

export default Login;
